import { Component, OnInit, OnDestroy } from '@angular/core'
import { WeatherStatusService, WindDirection } from '../../../../../services/weather-status.service'
import { HttpErrorResponse } from '@angular/common/http'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { IWeatherStatusModel } from '../../../../../models/weather-status.model'
import { Subject, Subscription } from 'rxjs'

@Component({
    selector: 'app-weather-status',
    templateUrl: './weather-status.component.html',
    styles: [
        `
      .arrow-up-left {
        transform: rotate(-45deg);
      }
      .arrow-up-right {
        transform: rotate(45deg);
      }
      .arrow-down-left {
        transform: rotate(45deg);
      }
      .arrow-down-right {
        transform: rotate(-45deg);
      }
    `
    ],
    standalone: false
})
export class WeatherStatusComponent implements OnInit, OnDestroy {
  private _interval: any
  private _subject: Subject<number> = new Subject<number>()
  private _subscription: Subscription

  private _isLoading: boolean = false
  private _weatherStatus: IWeatherStatusModel | null
  private _windDirection: WindDirection

  private _nextAt: number

  public get isLoading(): boolean {
    return this._isLoading
  }

  public get weatherStatus(): IWeatherStatusModel | null {
    return this._weatherStatus
  }

  public get windDirection(): WindDirection | null {
    return this._windDirection
  }

  constructor(
    private service: WeatherStatusService,
    private responseHandlerService: HttpResponseHandlerService,
  ) {}

  public getWindIconByDirection(direction: WindDirection): string {
    switch (direction) {
      case 'N':
        return 'fa fa-arrow-down' // 'fe fe-arrow-down'
      case 'N/NE':
      case 'NE':
      case 'E/NE':
        return 'fa fa-arrow-down arrow-down-left' // 'fe fe-arrow-down-left'
      case 'E':
        return 'fa fa-arrow-left' // 'fe fe-arrow-left'
      case 'E/SE':
      case 'SE':
      case 'S/SE':
        return 'fa fa-arrow-up arrow-up-left' // 'fe fe-arrow-up-left'
      case 'S':
        return 'fa fa-arrow-up' // 'fe fe-arrow-up'
      case 'S/SW':
      case 'SW':
      case 'W/SW':
        return 'fa fa-arrow-up arrow-up-right' // 'fe fe-arrow-up-right'
      case 'W':
        return 'fa fa-arrow-right' // 'fe fe-arrow-right'
      case 'W/NW':
      case 'NW':
      case 'N/NW':
        return 'fa fa-arrow-down arrow-down-right' // 'fe fe-arrow-down-right'
      default:
        return ''
    }
  }

  private getLast(): void {
    this._isLoading = true
    this.service.getLast(false).subscribe({
      next: (response: { weather: IWeatherStatusModel | null; next_at: number }) => {
        if (response.weather) {
          if (response.next_at && (!this._nextAt || this._nextAt != response.next_at)) {
            this._subject.next(response.next_at)
          }
          this._weatherStatus = response.weather
          this._nextAt = response.next_at
          this._windDirection = this.service.getWindDirectionByDegree(
            this._weatherStatus.Wind_From_Direction_Value,
          )
        }
        this._isLoading = false
      },
      error: (error: HttpErrorResponse) => {
        this.responseHandlerService.notifyError(error)
        this._isLoading = false
      }
    })
  }

  private getLastRecurrent(): void {
    this._subscription = this._subject.subscribe((nextAt: number) => {
      this.clearInterval()

      this._interval = setInterval(
        () => {
          this.getLast()
        },
        nextAt > 5 ? nextAt * 1000 : 5000,
      )
    })

    this.getLast()
  }

  private clearInterval(): void {
    if (this._interval) {
      clearInterval(this._interval)
    }
  }

  private clearSubscription(): void {
    if (this._subscription) {
      this._subscription.unsubscribe()
    }
  }

  ngOnInit(): void {
    this.getLastRecurrent()
  }

  ngOnDestroy(): void {
    this.clearInterval()
    this.clearSubscription()
  }
}
